import React from "react";
import { Link } from "react-router-dom";

export default function ImpressumPage() {
  return (
    <div className="mx-auto max-w-3xl space-y-8 px-2 py-2" data-testid="impressum-page">
      <header className="space-y-2">
        <p className="text-xs uppercase tracking-[0.18em] text-zinc-500">Rechtliches</p>
        <h1 className="text-4xl font-semibold tracking-tight text-zinc-100 sm:text-5xl">Impressum</h1>
        <p className="text-sm text-zinc-400">
          Angaben gemäß § 5 ECG / § 24 MedienG (Österreich) und § 5 TMG (Deutschland).
        </p>
      </header>

      <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <h2 className="text-lg font-medium text-zinc-100">Anbieter / Betreiber</h2>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Cloud Service International j.d.o.o.<br />
          Sitz: Zagreb, Kroatien (HR)<br />
          Handelsregister: Trgovački sud u Zagrebu<br />
          UID-Nr. (VAT-ID): wird auf Anfrage mitgeteilt
        </p>
      </section>

      <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <h2 className="text-lg font-medium text-zinc-100">Kontakt</h2>
        <p className="text-sm text-zinc-300 leading-relaxed">
          E-Mail:{" "}
          <a className="text-emerald-400 underline-offset-4 hover:underline" href="mailto:info@dealalert.ai">
            info@dealalert.ai
          </a>
          <br />
          Web:{" "}
          <a className="text-emerald-400 underline-offset-4 hover:underline" href="https://dealalert.ai">
            https://dealalert.ai
          </a>
        </p>
      </section>

      <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <h2 className="text-lg font-medium text-zinc-100">Unternehmensgegenstand</h2>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Betrieb der SaaS-Anwendung „DealAlert" — eine KI-gestützte Marktintelligenz-Plattform für
          Auto- und Immobilien-Inserate. Bereitstellung von Markt-Signalen, Preis-Analysen und KI-Empfehlungen
          auf Basis öffentlich verfügbarer Inseratsdaten.
        </p>
      </section>

      <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <h2 className="text-lg font-medium text-zinc-100">Verantwortlich für den Inhalt</h2>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Geschäftsführung Cloud Service International j.d.o.o.<br />
          Erreichbar unter info@dealalert.ai.
        </p>
      </section>

      <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <h2 className="text-lg font-medium text-zinc-100">Streitbeilegung</h2>
        <p className="text-sm text-zinc-300 leading-relaxed">
          Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:{" "}
          <a
            className="text-emerald-400 underline-offset-4 hover:underline"
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section className="rounded-2xl border border-zinc-800 bg-zinc-900/40 p-6 space-y-3">
        <h2 className="text-lg font-medium text-zinc-100">Haftung für Inhalte</h2>
        <p className="text-sm text-zinc-300 leading-relaxed">
          DealAlert aggregiert und analysiert Inseratsdaten von Drittplattformen. Wir übernehmen keine Gewähr
          für Richtigkeit, Vollständigkeit oder Aktualität dieser Daten. Marktsignale, KI-Antworten und
          Preisindikatoren sind algorithmische Schätzungen — keine Finanz-, Anlage- oder Kaufberatung. Details
          siehe <Link className="text-emerald-400 underline-offset-4 hover:underline" to="/agb">AGB</Link>.
        </p>
      </section>

      <p className="text-xs text-zinc-500">Stand: Juni 2026</p>
    </div>
  );
}
